import { InjectionToken } from '@angular/core';
import { zip } from 'rxjs';
import { AuthenticationConfigurations } from './models/authentication-configurations.model';
import { BooleanRawvaluesMappingConfigurations } from './models/boolean-rawvalues-mapping-configurations.model';
import { Configurations } from './models/configurations.model';
import { EnvironmentConfigurations } from './models/environment-configurations.model';
import { RawValueNameConfigurations } from './models/rawvalues-names-configurations.model';
import { IconConfiguration } from './models/icon-configurations.model';

export const APP_CONFIG = new InjectionToken<Configurations>('configurations');

export const configurationsFactory = () => {
  return new Promise(async (resolve, reject) => {

    zip(
      getEnvironmentConfigurations(),
      getAuthenticationConfigurations(),
      getRawValuesNamesConfigurations(),
      getBooleanRawValuesMappingConfigurations(),
      getIconsConfigurations()
    ).subscribe(config => {

      const configurations: Configurations = {
        environmentConfig: config[0],
        authenticationConfig: config[1],
        rawvaluesNamesConfig: config[2],
        booleanRawvaluesMappingConfig: config[3],
        iconsConfig: config[4]
      }

      resolve(configurations)
    })
  });
}

const isIntranet = document.URL.includes('intranet')

const getEnvironmentConfigurations = () => {
  const url = isIntranet ? `/assets/configurations/environment.intranet.config.json` : `/assets/configurations/environment.config.json`
  return (fetch(url).then(res => res.json() as Promise<EnvironmentConfigurations>))
}

const getAuthenticationConfigurations = () => {
  const url = `/assets/configurations/authentication.config.json`
  return fetch(url).then(res => res.json() as Promise<AuthenticationConfigurations>)
}

const getRawValuesNamesConfigurations = () => {
  const url = `/assets/configurations/rawvalues-names.config.json`
  return fetch(url).then(res => res.json() as Promise<RawValueNameConfigurations>)
}

const getBooleanRawValuesMappingConfigurations = () => {
  const url = `/assets/configurations/booleans-rawvalues-mapping.config.json`
  return fetch(url).then(res => res.json() as Promise<BooleanRawvaluesMappingConfigurations>)
}

const getIconsConfigurations = () => {
  const url = `/assets/configurations/icons.config.json`
  return fetch(url).then(res => res.json() as Promise<IconConfiguration[]>)
}